import React from 'react';

/**
 * Cover page for the Managerial Cross Report.
 *
 * Props:
 *   orgLogo      {string|null}  base64 or URL of the client logo
 *   orgName      {string|null}  organisation display name
 *   reportQuarter {string}      e.g. "Q2 - 2026"
 *   reportYear   {number}       e.g. 2026
 */
const ManCrossPageCover = ({ orgLogo, orgName, reportQuarter, reportYear }) => (
    <div className="mgcr-cover">

        {/* Top-left: Talentha white logo */}
        <div className="mgcr-cover-brand">
            <img src="/talentha-blanco.png" alt="Talentha" className="mgcr-cover-logo" />
        </div>

        {/* Centred title block */}
        <div className="mgcr-cover-header-copy">
            <h1 className="mgcr-cover-title">
                INFORME GERENCIAL DEL SISTEMA PREDICTIVO DE SEGURIDAD TALENTHA
            </h1>
            <div className="mgcr-cover-divider" />
            <div className="mgcr-cover-subtitle">
                ANÁLISIS CRUZADO DE LIDERAZGO, AUTOCUIDADO Y SAFETY NPS
            </div>
        </div>

        {/* Bottom-left: org logo + name | quarter + slogan pill */}
        <div className="mgcr-cover-meta">
            {orgLogo ? (
                <img
                    className="mgcr-cover-org-logo"
                    src={orgLogo}
                    alt="Logo organización"
                />
            ) : null}
            <div className="mgcr-cover-meta-bottom">
                {orgName ? <span className="mgcr-cover-meta-org">{orgName}</span> : null}
                {orgName ? <span className="mgcr-cover-meta-sep">|</span> : null}
                <span className="mgcr-cover-meta-period">{reportQuarter}</span>
            </div>
            <div className="mgcr-cover-footer-pill">
                Identificando dónde concentrar la intervención para prevenir el próximo accidente grave.
            </div>
        </div>

        {/* Right: year stack */}
        <div className="mgcr-cover-year-stack">
            {[...String(reportYear)].map((digit, i) => (
                <div key={`y${i}`}>{digit}</div>
            ))}
        </div>

    </div>
);

export default ManCrossPageCover;
